import { DateTime } from 'luxon';

/** Time-of-day greeting in the user's timezone. */
export function greetingForHour(hour: number): string {
  if (hour < 5) return 'Good night';
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  if (hour < 21) return 'Good evening';
  return 'Good night';
}

/** Fallback when profile first name is not set. */
export function nameFromEmail(email: string): string {
  const local = email.split('@')[0] ?? email;
  const part = local.split(/[._-]/)[0] ?? local;
  if (!part) return 'there';
  return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
}

/** Greeting name: profile first name, then email-derived fallback. */
export function greetingName(user: {
  first_name?: string | null;
  email: string;
}): string {
  const trimmed = user.first_name?.trim();
  if (trimmed) return trimmed;
  return nameFromEmail(user.email);
}

/** Today's calendar bounds in the user's IANA timezone. */
export function todayRange(timezone: string): { start: Date; end: Date } {
  const now = DateTime.now().setZone(timezone);
  return {
    start: now.startOf('day').toJSDate(),
    end: now.endOf('day').toJSDate(),
  };
}

export function formatTodayHeading(timezone: string): string {
  return DateTime.now().setZone(timezone).toFormat('cccc, LLLL d');
}
